import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Button } from "~frontend/components/ui/button";
import { trpc } from "~frontend/router";

export const Route = createFileRoute("/_LoggedIn/dashboard")({
    component: DashboardHome,
});

function DashboardHome() {
    const { data, isLoading } = useQuery(trpc.hello.hello.queryOptions("hello"));

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
                <p className="text-muted-foreground">
                    Welcome to the KCC platform dashboard.
                </p>
            </div>

            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
                <div className="rounded-xl border bg-card text-card-foreground shadow">
                    <div className="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
                        <h3 className="tracking-tight text-sm font-medium">Total Students</h3>
                    </div>
                    <div className="p-6 pt-0">
                        <div className="text-2xl font-bold">1,234</div>
                        <p className="text-xs text-muted-foreground">
                            +20.1% from last month
                        </p>
                    </div>
                </div>

                <div className="rounded-xl border bg-card text-card-foreground shadow">
                    <div className="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
                        <h3 className="tracking-tight text-sm font-medium">Active Courses</h3>
                    </div>
                    <div className="p-6 pt-0">
                        <div className="text-2xl font-bold">45</div>
                        <p className="text-xs text-muted-foreground">
                            +5 new this semester
                        </p>
                    </div>
                </div>

                <div className="rounded-xl border bg-card text-card-foreground shadow">
                    <div className="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
                        <h3 className="tracking-tight text-sm font-medium">Attendance Rate</h3>
                    </div>
                    <div className="p-6 pt-0">
                        <div className="text-2xl font-bold">94.2%</div>
                        <p className="text-xs text-muted-foreground">
                            +2.1% from last week
                        </p>
                    </div>
                </div>

                <div className="rounded-xl border bg-card text-card-foreground shadow">
                    <div className="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
                        <h3 className="tracking-tight text-sm font-medium">API Status</h3>
                    </div>
                    <div className="p-6 pt-0">
                        <div className="text-2xl font-bold">
                            {isLoading ? "Loading..." : data || "Connected"}
                        </div>
                        <p className="text-xs text-muted-foreground">
                            Backend connection status
                        </p>
                    </div>
                </div>
            </div>

            <div className="rounded-xl border bg-card text-card-foreground shadow">
                <div className="p-6">
                    <h3 className="text-lg font-semibold">Quick Actions</h3>
                    <div className="mt-4 flex gap-2">
                        <Button>View Students</Button>
                        <Button variant="outline">Manage Courses</Button>
                        <Button variant="outline">Attendance Report</Button>
                    </div>
                </div>
            </div>
        </div>
    );
} 